import React from 'react';
import { brandName, footerLinks } from '../data/navigation';

const Footer = () => {
    const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>&copy; {year} {brandName}</p>
          <div className="footer-links">
            {footerLinks.map((link, index) => (
              <a key={index} href={link.href}>{link.label}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default React.memo(Footer);